/* "import "redux"" is auto-generated by Snack after importing from "react-redux" */
import "redux" // 3.7.2
// @TO-DO: Delete above after Snack fix this bug

import React, { Component } from 'react'
import { Provider } from 'react-redux' // 5.0.6


import store from './state/Store'
import { RootNavigator } from './navigation'

export default class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <RootNavigator />
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js